import { useTranslation } from 'react-i18next';
import { formatToDate } from 'utils/formatToDate';

import { DocumentModel } from 'api/documents/documents.model';
import CompositionRow from 'components/CompositionRow/CompositionRow';
import Detail from 'components/Detail';
import SectionTitle from 'components/SectionTitle';
import SubTitle from 'components/SubTitle';
import useCertificateHelper from 'hooks/useCertificateHelper';
import {
  ADDITIONAL_DETAILS,
  CertificateDetailsModel,
  CHEMICAL_COMPOSITION_TEST_RESULTS_DETAILS,
  NESTED_DETAILS,
  PARTICLE_SIZE_DISTRIBUTION_DETAILS,
  PHYSICAL_PROPERTIES_DETAILS,
} from 'models/certificate.model';

import RelatedDocument from '../RelatedDocument';
import Template from '../Template';

const ChemistryTestResults = ({
  additionalDetails = {} as CertificateDetailsModel,
  ...document
}: DocumentModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();
  const { getLabel } = useCertificateHelper();

  return (
    <Template
      document={{
        additionalDetails,
        ...document,
      }}
      rigthCard={
        <>
          <Detail
            label={getLabel(ADDITIONAL_DETAILS.TEST_DATE)}
            value={formatToDate(additionalDetails[ADDITIONAL_DETAILS.TEST_DATE])}
          />
          <Detail
            label={t('document.dateOfPublication')}
            value={formatToDate(document.publicationDate)}
          />
          <Detail
            label={getLabel(ADDITIONAL_DETAILS.CHEMISTRY_MARKET_NAME)}
            value={additionalDetails[ADDITIONAL_DETAILS.CHEMISTRY_MARKET_NAME]}
          />
          <RelatedDocument
            relatedDocumentProductId={additionalDetails[NESTED_DETAILS.CHEMISTRY_BATCH_NUMBER]}
          >
            <Detail
              label={getLabel(ADDITIONAL_DETAILS.CHEMISTRY_BATCH_NUMBER)}
              value={additionalDetails[ADDITIONAL_DETAILS.CHEMISTRY_BATCH_NUMBER]}
            />
          </RelatedDocument>
        </>
      }
    >
      <SectionTitle>{getLabel('specification')}</SectionTitle>

      <SubTitle>{getLabel(ADDITIONAL_DETAILS.CHEMICAL_COMPOSITION)}</SubTitle>
      <CompositionRow<CHEMICAL_COMPOSITION_TEST_RESULTS_DETAILS>
        composition={additionalDetails[ADDITIONAL_DETAILS.CHEMICAL_COMPOSITION_TEST_RESULTS]}
        labels={Object.values(CHEMICAL_COMPOSITION_TEST_RESULTS_DETAILS)}
      />

      <SubTitle>{getLabel(ADDITIONAL_DETAILS.PHYSICAL_PROPERTIES)}</SubTitle>
      <CompositionRow<PHYSICAL_PROPERTIES_DETAILS>
        composition={additionalDetails[ADDITIONAL_DETAILS.PHYSICAL_PROPERTIES_TEST_RESULTS]}
        labels={Object.values(PHYSICAL_PROPERTIES_DETAILS)}
      />

      <SubTitle>{getLabel(ADDITIONAL_DETAILS.PARTICLE_SIZE_DISTRIBUTION)}</SubTitle>
      <CompositionRow<PARTICLE_SIZE_DISTRIBUTION_DETAILS>
        composition={additionalDetails[ADDITIONAL_DETAILS.PARTICLE_SIZE_DISTRIBUTION_TEST_RESULTS]}
        labels={Object.values(PARTICLE_SIZE_DISTRIBUTION_DETAILS)}
      />
    </Template>
  );
};

export default ChemistryTestResults;
